import type { ChecklistItem, Check, ColorState } from './types';
import { previousEligibleDays } from './dates';

export function computeColorState(item: ChecklistItem, checksForItem: Check[], today: string): ColorState {
  const dates = new Set(checksForItem.map((c) => c.date));
  if (dates.has(today)) return 'normal';

  // No history at all — treat as normal (item is new / not yet used)
  if (checksForItem.length === 0) return 'normal';

  // Count consecutive missed eligible days going backwards from today
  const eligible = previousEligibleDays(today, 2, item.weekdaysOnly);
  let consecutiveMisses = 0;
  for (const d of eligible) {
    if (!dates.has(d)) {
      consecutiveMisses++;
    } else {
      break;
    }
  }

  if (consecutiveMisses === 0) return 'normal';
  if (consecutiveMisses === 1) return 'orange';
  return 'red';
}
